import classNames from 'classnames'
import React from 'react'
import CheckIcon from '../assets/icons/check.svg'
import { isNullOrWhiteSpace } from '../utilities/string'
import { Paragraph } from './Paragraph'
import { SupText } from './SupText'

export interface PageIntroChecklistProps {
  bullets?: string[]
  complementaryText?: string
  title?: string
}

export const PageIntroChecklist = ({
  bullets,
  complementaryText,
  title,
}: PageIntroChecklistProps) => (
  <div
    className={classNames(
      'flex flex-col gap-30 p-30 rounded-15 bg-shade-lightest-warm',
      'tb:p-45',
      'lg:p-60'
    )}
  >
    {!isNullOrWhiteSpace(title) && (
      <h3 className="pb-15 border-b font-h2 text-h2 text-secondary-darker border-neutral-light">
        {title}
      </h3>
    )}

    {!!bullets?.length && (
      <ul className="flex flex-col gap-15 list-none">
        {bullets.map((bullet, index) => (
          <li className="flex gap-15 py-4" key={index}>
            <div className="flex-none flex justify-center items-center w-[24px] h-[24px] rounded-5 bg-shade tb:mt-1 lg:mt-5">
              <CheckIcon className="w-[10px] h-[10px] fill-neutral" />
            </div>

            <SupText
              as={'span'}
              className="font-t text-t-400 text-secondary-darkest tb:text-t-500 lg:text-t-600"
            >
              {bullet}
            </SupText>
          </li>
        ))}
      </ul>
    )}

    {!isNullOrWhiteSpace(complementaryText) && (
      <Paragraph className="font-t-bold text-t-400 text-secondary-darkest tb:text-t-500 lg:text-t-600">
        {complementaryText}
      </Paragraph>
    )}
  </div>
)
